const log = require('log').create('checklist', 'item') // eslint-disable-line
const { ONE_MINUTE } = require('lib/time')

const CACHE_TIME = ONE_MINUTE

class ChecklistItem {

    constructor(options) {
        this.options = options
        this.id = options.id
        this.user = options.user
        this.state_updated = 0
        if (__DEBUG__ || __KARMA__) {
            if (typeof options.completed !== 'function') {
                throw new Error('ChecklistItem requires options.completed')
            }
        }
    }

    getState() {
        // cache state for 1 minutes
        if (Date.now() - this.state_updated < CACHE_TIME) {
            return Promise.resolve(this)
        }

        return new Promise(resolve => {
            Promise.all([
                this.isApplicable(),
                this.isCompleted(),
            ])
                .then(([applicable, completed]) => {
                // items can set disable_cache: true to prevent their
                // applicable/completed state from being cached and force
                // applicable/completed logic to be run on every user change
                    if (! this.options.disable_cache) {
                        this.state_updated = Date.now()
                    }
                    resolve(this)
                })
        })
    }

    isApplicable() {
        return new Promise(resolve => {
            this.getApplicable().then(applicable => {
                this.applicable = applicable
                resolve(applicable)
            })
        })
    }

    getApplicable() {
        const { applicable } = this.options
        if (! applicable) return Promise.resolve(true)
        const result = applicable.call(this)
        return Promise.resolve(result)
    }

    isCompleted() {
        return new Promise(resolve => {
            this.getCompleted().then(completed => {
                this.completed = completed
                resolve(completed)
            })
        })
    }

    getCompleted() {
        const { completed } = this.options
        const result = completed.call(this)
        return Promise.resolve(result)
    }

}

module.exports = ChecklistItem
